import Icon, {ilsNoSearch} from "../Icon";
import React from "react";
import '../../../assets/sass/components/feedback/no-result-found.scss';

const NoResultFound = props => {
    const text = props.text || "Sorry, No result found";
    const details = props.details || "We can’t find any item.";

    return (
        <div className="feedback-no-result-found">
            <Icon className="feedback-no-result-found--icon" svg={ilsNoSearch}/>
            <span className="feedback-no-result-found--text"> {text} </span>
            <span className="feedback-no-result-found--details"> {details} </span>
        </div>
    );
};

export default NoResultFound;
